import "react-notion/src/styles.css";
import NotionView from "../components/NotionView";
// import fs from "fs";

function Review() {
    return <NotionView pageId={"ce039ebcfdea42b3b941528f76c294b9"} />;
}

export default Review;
